import {createSlice} from '@reduxjs/toolkit';
import {httpGet, httpPost} from '../../../util/Rest';
import {submissionEnd} from '../CommonActions/commonActions';

const initialState = {
  isLoading: false,
  successMessage: null,
  errorMessage: null,
  addTranslationStatus: null,
  translationData: [],
  translationMainData: {},
  translationFieldData: {},
  addTranslationFieldStatus: null,
  allTranslationCodes: [],
};

const translationTable = createSlice({
  name: 'translationTable',
  initialState,
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMessage = null;
    },
    fetchError: (state, action) => {
      state.errorMessage = action.payload;
      state.isLoading = false;
    },
    getTranslationData: (state, action) => {
      state.isLoading = false;
      state.successMessage = null;
      state.errorMessage = null;
      state.translationData = action.payload;
    },
    getTranslationMainData: (state, action) => {
      state.isLoading = false;
      state.successMessage = null;
      state.errorMessage = null;
      state.translationMainData = action.payload;
    },
    getAllTranslationCodes: (state, action) => {
      state.allTranslationCodes = action.payload;
      state.isLoading = false;
      state.errorMessage = null;
    },
    getTranslationFieldData: (state, action) => {
      state.isLoading = false;
      state.successMessage = null;
      state.errorMessage = null;
      state.translationFieldData = action.payload;
    },
    postTranslationTable: (state, action) => {
      state.isLoading = false;
      state.successMessage = action.payload?.response;
      state.errorMessage = null;
      state.addTranslationStatus = action.payload?.status;
    },
    postTranslationField: (state, action) => {
      state.isLoading = false;
      state.successMessage = action.payload?.response;
      state.errorMessage = null;
      state.addTranslationFieldStatus = action.payload?.status;
    },
    resetTransitionTableData: (state) => {
      state.isLoading = false;
      state.successMessage = null;
      state.errorMessage = null;
      state.addTranslationStatus = null;
      state.translationData = [];
      state.translationMainData = {};
    },
    resetTranslationMainData: (state) => {
      state.isLoading = false;
      state.successMessage = null;
      state.errorMessage = null;
      state.addTranslationStatus = null;
      state.addTranslationFieldStatus = null;
    },
  },
});
export default translationTable.reducer;

const {
  fetchError,
  fetchStart,
  getTranslationData,
  getTranslationMainData,
  resetTransitionTableData,
  postTranslationTable,
  resetTranslationMainData,
  getTranslationFieldData,
  postTranslationField,
  getAllTranslationCodes,
} = translationTable.actions;
export const fetchTransitionData = (transitionCode) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`data-manager/record/get/translationvalues/${transitionCode}`)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(getTranslationData(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const fetchTransitionMainData = (transitionCode) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`data-manager/record/get/translation/${transitionCode}`)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(getTranslationMainData(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const fetchTranslationFieldData = (transitionCode) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`data-manager/record/get/translationvalues/${transitionCode}`)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(getTranslationFieldData(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const postTranslationTableData = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`data-manager/record/save/translationdetails`, details)
      .then((data) => {
        dispatch(submissionEnd());
        if (data && data.status && data.status === 200) {
          dispatch(postTranslationTable(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const postTranslationFieldData = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`data-manager/record/save/translationvalues`, details)
      .then((data) => {
        dispatch(submissionEnd());
        if (data && data.status && data.status === 200) {
          dispatch(postTranslationField(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const fetchAllTranslationCodes = () => {
  return (dispatch) => {
    httpGet(`data-manager/record/find/all/translationcodes`)
      .then((data) => {
        if (data?.status && data.status === 200) {
          dispatch(getAllTranslationCodes(data?.response));
        } else {
          dispatch(fetchError(data?.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};


export const resetTransitionTable = () => {
  return (dispatch) => {
    dispatch(resetTransitionTableData());
  };
};
export const resetMainTranslation = () => {
  return (dispatch) => {
    dispatch(resetTranslationMainData());
  };
};
